import ApiService from './ApiService'

export default {
    saveTranslation({ group, key, values }) {
        return ApiService.post('/admin/translations/save', { group, key, values })
    },
}
